import { LazyRouteFunction, RouteObject } from 'react-router-dom';

type LazyRoute = Awaited<ReturnType<LazyRouteFunction<RouteObject>>>;

export async function lazyComponent(
  importFunction: Promise<any>,
  field = 'default',
): Promise<LazyRoute> {
  const importResult = await importFunction;

  return { Component: importResult[field] };
}

export async function lazyWrapComponent(
  lazyRoutePromise: Promise<LazyRoute>,
  Component: (props: { children: React.ReactNode }) => React.ReactNode,
): Promise<LazyRoute> {
  const lazyRoute = await lazyRoutePromise;
  const RouteComponent = lazyRoute.Component;
  if (RouteComponent) {
    lazyRoute.Component = (props) => (
      <Component>
        <RouteComponent {...props} />
      </Component>
    );
  }
  return lazyRoute;
}
